const namespace = "mttFinished";

export const WINNING_TITLE = `${namespace}.winningTitle`;
export const WINNING_DESCRIPTION = `${namespace}.winningDescription`;
export const ELIMINATED_TITLE = `${namespace}.eliminatedTitle`;
export const ELIMINATED_DESCRIPTION = `${namespace}.eliminatedDescription`;
export const WATCH_GAME = `${namespace}.watchGame`;
export const CLOSE_TABLE = `${namespace}.closeTable`;
